import React, { useContext, useEffect, useState } from 'react';
import { generateTextField } from '../../b2b-common/helpers';
import { LoginContext } from '../../../App';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import { Add, Delete, Save } from '@mui/icons-material';
import './LabelDetailsModal.css';
import { Box, ButtonGroup, IconButton, Tab, Tabs, TextField, Typography } from '@mui/material';
import { LocaleTabs, TabPanel, TranslationTextField } from '../components/helper';
import { removeAllKeyTranslations, saveNewTranslation } from '../../../services/b2b-languages-apiService';
import LocaleNewDialog from '../components/LocaleNewDialog';

const LabelDetailsModal = ({ open, labelTranslations, onLabelUpdate, onClose }) => {
    const { loginData } = useContext(LoginContext);
    const [tabValue, setTabValue] = useState(0);
    const [translations, setTranslations] = useState(labelTranslations);

    useEffect(() => {
        setTranslations(labelTranslations);
    }, [labelTranslations]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleDeleteTranslations = async () => {
        try {
            await removeAllKeyTranslations(translations.sameLabelTranslations[0].key, loginData.accessToken)
            console.log(`All translations for [${translations.sameLabelTranslations[0].key}] deleted successfully.`);
            if (onLabelUpdate)
                onLabelUpdate();
            onClose();
        } catch (error) {
            console.error('Error deleting translations:', error);
        }
    };

    const handleTranslationChange = (index, newContent) => {
        setTranslations(prevTranslations => {
            const updatedTranslations = [...prevTranslations.sameLabelTranslations];
            updatedTranslations[index] = { ...updatedTranslations[index], content: newContent };
            return { ...prevTranslations, sameLabelTranslations: updatedTranslations };
        });
    };

    const handleSaveAllTranslations = async () => {
        try {
            for (const translation of translations.sameLabelTranslations)
                await saveNewTranslation(translation, loginData.accessToken);
            console.log('All translations saved successfully.');
            if (onLabelUpdate)
                onLabelUpdate();
            onClose();
        } catch (error) {
            console.error('Error saving translations:', error);
        }
    };

    const [showLocaleRequest, setShowLocaleRequest] = useState(false);

    const handleAddingNewLocale = async (newLocale) => {
        const newTranslation = {
            "languageId": null,
            "locale": newLocale,
            "key": translations.sameLabelTranslations[0].key,
            "content": ""
        }
        setTranslations(prevState => ({
            ...prevState,
            sameLabelTranslations: [...prevState.sameLabelTranslations, newTranslation]
        }));
        setShowLocaleRequest(false)
    }

    const translationsButtons = [
        <IconButton
            key="new"
            onClick={() => setShowLocaleRequest(true)}
            className="translations-management-button"
        >
            <Add />
            <Typography variant="body2">New Locale</Typography>
        </IconButton>,
    ];

    //console.log('labelTranslations', labelTranslations);
    const checkConditions = translations && translations.sameLabelTranslations && translations.sameLabelTranslations.length > 0;
    return (
        <>
            <B2BPopUpForm
                open={open}
                title={<span>Label key translations</span>}
                buttons={[
                    {
                        label: 'Save all translations',
                        confirm: false,
                        onClick: handleSaveAllTranslations,
                        icon: <Save />
                    },
                    {
                        label: 'Delete all translations',
                        confirm: true,
                        onConfirm: handleDeleteTranslations,
                        icon: <Delete />
                    },
                ]}
                onClose={onClose}
                className={'label-translations-modal'}
            >
                {generateTextField("Key", (checkConditions) ? translations.sameLabelTranslations[0].key : "", "label-key-ro-textfield")}
                <ButtonGroup size="small" aria-label="small button group" className="b2b-default-button-group">
                    {translationsButtons}
                </ButtonGroup>
                <LocaleTabs
                    value={tabValue}
                    translations={translations}
                    onTabChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="off"
                    aria-label="translation tabs"
                />
                {checkConditions && translations.sameLabelTranslations.map((translation, index) => (
                    <TabPanel key={index} value={tabValue} index={index} className='tab-panel-locale-translation'>
                        <TranslationTextField translation={translation}
                            index={index} onTranslationChange={handleTranslationChange} />
                    </TabPanel>
                ))}
            </B2BPopUpForm>
            {
                showLocaleRequest && <LocaleNewDialog onAddingNewLocale={handleAddingNewLocale} />
            }
        </>
    )
}

export default LabelDetailsModal;